"use client";

import { useState } from "react";
import { Badge, Button, UncontrolledTooltip } from "reactstrap";

const OrderTableItem = ({ order, onView, onDelete, onUpdateStatus }) => {
  const [showActions, setShowActions] = useState(false);
  const [showStatusPicker, setShowStatusPicker] = useState(false);

  const getStatusBadge = (status) => {
    const statusConfig = {
      pending: { color: "warning", text: "Pending" },
      confirmed: { color: "info", text: "Confirmed" },
      processing: { color: "primary", text: "Processing" },
      shipped: { color: "success", text: "Shipped" },
      delivered: { color: "success", text: "Delivered" },
      cancelled: { color: "danger", text: "Cancelled" },
      refunded: { color: "secondary", text: "Refunded" },
    };

    const config = statusConfig[status] || {
      color: "secondary",
      text: "Unknown",
    };
    return <Badge color={config.color}>{config.text}</Badge>;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatCurrency = (amount) => {
    return `$${Number.parseFloat(amount).toFixed(2)}`;
  };

  const handleStatusChange = (newStatus) => {
    if (newStatus !== order.status) {
      if (
        window.confirm(
          `Change order status to ${
            newStatus.charAt(0).toUpperCase() + newStatus.slice(1)
          }?`
        )
      ) {
        onUpdateStatus(newStatus);
      }
    }
    setShowStatusPicker(false);
  };

  const statusOptions = [
    "pending",
    "confirmed",
    "processing",
    "shipped",
    "delivered",
    "cancelled",
    "refunded",
  ];

  const truncateText = (text, maxLength = 30) => {
    if (!text) return "";
    return text.length > maxLength
      ? text.substring(0, maxLength) + "..."
      : text;
  };

  return (
    <tr>
      <td className="order_id">
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0">
            <span className="fw-semibold">
              #{order.order_number || order.id}
            </span>
          </div>
        </div>
      </td>

      <td className="customer">
        <div>
          <h6 className="mb-1">{order.user?.name || "Unknown Customer"}</h6>
          <p className="text-muted mb-0 small">{order.user?.email || "N/A"}</p>
        </div>
      </td>

      <td className="items">
        <div>
          <span className="fw-semibold">
            {order.total_quantity || order.order_items?.length || 0}
          </span>
          <p className="text-muted mb-0 small">
            {order.order_items && order.order_items.length > 0
              ? truncateText(order.order_items[0].product_name, 20)
              : "No items"}
          </p>
        </div>
      </td>

      <td className="total">
        <span className="fw-semibold text-success">
          {formatCurrency(order.total || order.total_amount || 0)}
        </span>
      </td>

      <td className="status">
        <div className="position-relative">
          <div
            className="d-flex align-items-center cursor-pointer"
            onClick={() => setShowStatusPicker(!showStatusPicker)}
          >
            {getStatusBadge(order.status)}
            <i className="ri-arrow-down-s-line ms-1"></i>
          </div>

          {showStatusPicker && (
            <div
              className="position-absolute bg-white border rounded shadow-sm p-2 mt-1"
              style={{ zIndex: 1000, minWidth: "150px" }}
            >
              {statusOptions.map((status) => (
                <div
                  key={status}
                  className="p-2 cursor-pointer hover-bg-light"
                  onClick={() => handleStatusChange(status)}
                  style={{ cursor: "pointer" }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#f8f9fa")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "transparent")
                  }
                >
                  {status.charAt(0).toUpperCase() + status.slice(1)}
                </div>
              ))}
            </div>
          )}
        </div>
      </td>

      <td>
        <div className="d-flex gap-2">
          <div className="show">
            <Button
              color="primary"
              size="sm"
              id={`show-${order.id}`}
              onClick={() => onView(order.id)}
              className="btn-icon"
            >
              <i className="ri-eye-fill"></i>
            </Button>
            <UncontrolledTooltip placement="top" target={`show-${order.id}`}>
              View Details
            </UncontrolledTooltip>
          </div>

          <div className="remove">
            <Button
              color="danger"
              size="sm"
              id={`delete-${order.id}`}
              onClick={() => onDelete(order.id)}
              className="btn-icon"
            >
              <i className="ri-delete-bin-fill"></i>
            </Button>
            <UncontrolledTooltip placement="top" target={`delete-${order.id}`}>
              Delete Order
            </UncontrolledTooltip>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default OrderTableItem;
